import { IRootState } from 'reducers';

export const configSelector = (state: IRootState) => state.config.data;
